import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-status"
export default class extends Controller {
  static targets = [ "reason" ]
  changed(e) {
    if (e.target.value == "archived") {
      this.reasonTarget.classList.remove("hidden");
    } else {
      this.reasonTarget.classList.add("hidden");
    }
  }
}
